(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function pad(n){return (n<10?'0':'')+n}

  /* Countdown: only runs when a real end date is configured */
  var promo=$('[data-promo]');
  if(promo){
    var raw=(promo.getAttribute('data-end')||'').trim(), cd=$('[data-cd]',promo);
    var end=raw?new Date(raw.replace(' ','T')):null;
    if(end&&!isNaN(end)&&end>new Date()&&cd){
      cd.hidden=false;
      var tick=function(){
        var t=Math.max(0,end-new Date());
        if(t<=0){cd.hidden=true;return}
        var s=Math.floor(t/1000);
        $('[data-d]',cd).textContent=pad(Math.floor(s/86400));
        $('[data-h]',cd).textContent=pad(Math.floor(s%86400/3600));
        $('[data-m]',cd).textContent=pad(Math.floor(s%3600/60));
        $('[data-s]',cd).textContent=pad(s%60);
        setTimeout(tick,1000);
      };tick();
    }
  }

  $$('[data-flip]').forEach(function(b){
    b.addEventListener('click',function(){
      var c=b.closest('.b-card'); var on=c.classList.toggle('show-real');
      b.textContent=on?b.getAttribute('data-off'):b.getAttribute('data-on');
    });
  });

  var eta=$('[data-eta]');
  if(eta){try{
    var add=function(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w&&w<6)n--}return d};
    var f=function(d){return d.toLocaleDateString('en-US',{month:'short',day:'numeric'})};
    var now=new Date();$('[data-eta-range]',eta).textContent=f(add(now,8))+' – '+f(add(now,18));eta.hidden=false;
  }catch(e){}}

  var rv=$$('.b-rv');
  if('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    rv.forEach(function(el){io.observe(el)});
  } else rv.forEach(function(el){el.classList.add('in')});

  var root=$('[data-pdp]'); if(!root) return;
  var track=$('[data-track]',root), slides=$$('.b-slide',root);
  var view=$('[data-view]',root), viewTxt=$('[data-view-text]',root), viewImg=$('[data-view-img]',root);
  var thumbsWrap=$('[data-thumbs]',root);
  var idInput=$('[data-id]',root), vname=$('[data-vname]',root);
  var sticky=$('[data-sticky]'), sImg=$('[data-simg]'), sName=$('[data-sname]');
  var legends=$$('[data-variant]',root);
  var current='';

  function idx(){return Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))))}
  function go(i,smooth){i=(i+slides.length)%slides.length;track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'})}
  function firstOf(t){for(var i=0;i<slides.length;i++){if(slides[i].getAttribute('data-legend')===t)return i}return 0}

  /* thumbnails for every photo */
  slides.forEach(function(s,k){
    var b=document.createElement('button');b.type='button';b.setAttribute('data-kind',s.getAttribute('data-kind'));
    b.setAttribute('aria-label',s.getAttribute('data-legend')+' on the slopes');
    b.innerHTML='<img alt="" loading="lazy" src="'+s.getAttribute('data-thumb')+'">';
    b.addEventListener('click',function(){go(k)});thumbsWrap.appendChild(b);
  });
  var thumbs=$$('button',thumbsWrap);

  function select(btn,fromGallery){
    legends.forEach(function(b){b.setAttribute('aria-pressed',b===btn?'true':'false')});
    idInput.value=btn.getAttribute('data-variant');
    idInput.dispatchEvent(new Event('change',{bubbles:true}));
    var t=btn.getAttribute('data-title'); current=t;
    if(vname) vname.textContent=t; if(sName) sName.textContent=t;
    if(sImg) sImg.src=btn.getAttribute('data-thumb');
    try{history.replaceState(null,'','?variant='+idInput.value)}catch(e){}
    if(!fromGallery) go(firstOf(t));
  }
  function setReal(s,on){
    s.classList.toggle('real',on);
    var r=$('.b-real',s); if(r){r.loading='eager';r.setAttribute('aria-hidden',on?'false':'true')}
  }
  function viewUi(cur){
    var on=cur.classList.contains('real');
    if(viewTxt) viewTxt.textContent=on?view.getAttribute('data-to-slopes'):view.getAttribute('data-to-real');
    if(viewImg) viewImg.src=cur.getAttribute(on?'data-thumb':'data-real-thumb');
  }
  function sync(){
    var i=idx(), cur=slides[i]; if(!cur) return;
    var t=cur.getAttribute('data-legend');
    slides.forEach(function(s,k){if(k!==i&&s.classList.contains('real'))setReal(s,false)});
    viewUi(cur);
    thumbs.forEach(function(b,k){b.setAttribute('aria-current',k===i)});
    var tb=thumbs[i]; if(tb){var l=tb.offsetLeft-(thumbsWrap.clientWidth-tb.clientWidth)/2;thumbsWrap.scrollTo({left:l,behavior:'smooth'})}
    if(t!==current){var btn=legends.filter(function(b){return b.getAttribute('data-title')===t})[0]; if(btn) select(btn,true)}
  }
  var raf; track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(sync)},{passive:true});
  window.addEventListener('resize',function(){go(idx(),false)});
  var prev=$('[data-prev]',root), next=$('[data-next]',root);
  if(prev) prev.addEventListener('click',function(){go(idx()-1)});
  if(next) next.addEventListener('click',function(){go(idx()+1)});
  if(view) view.addEventListener('click',function(){
    var cur=slides[idx()]; if(!cur) return;
    setReal(cur,!cur.classList.contains('real')); viewUi(cur);
  });

  legends.forEach(function(b){b.addEventListener('click',function(){select(b,false)})});
  $$('[data-choose]').forEach(function(b){
    b.addEventListener('click',function(){
      var t=legends.filter(function(x){return x.getAttribute('data-variant')===b.getAttribute('data-choose')})[0];
      if(t){select(t,false);root.scrollIntoView({behavior:'smooth',block:'start'})}
    });
  });
  var init=legends.filter(function(b){return b.getAttribute('aria-pressed')==='true'})[0]||legends[0];
  if(init){current=init.getAttribute('data-title');go(firstOf(current),false)}
  sync();

  var qty=$('[data-qty]',root), total=$('strong[data-total]',root), sTotal=$('[data-stotal]');
  var mixes=$$('[data-mix]',root);

  /* bundle pickers: one slot per mask, each with the 5 characters */
  function slotName(slot){var on=$('button[aria-pressed=true]',slot);return on?on.getAttribute('data-title'):''}
  function fillMix(mix){
    var n=+mix.getAttribute('data-mix'), wrap=$('[data-slots]',mix); if(wrap.children.length) return;
    var startIdx=Math.max(0,legends.map(function(b){return b.getAttribute('data-title')}).indexOf(current));
    for(var i=0;i<n;i++){
      var slot=document.createElement('div');slot.className='b-slot';
      slot.innerHTML='<div class="b-slot-h"><span>Mask '+(i+1)+'</span><b data-slot-name></b></div><div class="b-slot-opts" role="radiogroup" aria-label="Mask '+(i+1)+'"></div>';
      var opts=$('.b-slot-opts',slot), pick=legends[(startIdx+i)%legends.length];
      legends.forEach(function(l){
        var o=document.createElement('button');o.type='button';
        o.setAttribute('data-id',l.getAttribute('data-variant'));o.setAttribute('data-title',l.getAttribute('data-title'));
        o.setAttribute('aria-label',l.getAttribute('data-title'));o.setAttribute('aria-pressed',l===pick?'true':'false');
        o.innerHTML='<img alt="" loading="lazy" src="'+l.getAttribute('data-thumb')+'">';
        opts.appendChild(o);
      });
      $('[data-slot-name]',slot).textContent=slotName(slot);
      wrap.appendChild(slot);
    }
  }
  root.addEventListener('click',function(e){
    var o=e.target.closest('.b-slot-opts button'); if(!o) return;
    var slot=o.closest('.b-slot');
    $$('button',slot).forEach(function(b){b.setAttribute('aria-pressed',b===o?'true':'false')});
    $('[data-slot-name]',slot).textContent=o.getAttribute('data-title');
  });
  function openMix(n){
    mixes.forEach(function(m){var on=m.getAttribute('data-mix')===String(n);if(on)fillMix(m);m.classList.toggle('open',on)});
    root.classList.toggle('b-multi',n>1);
  }
  function mixItems(){
    var m=mixes.filter(function(x){return x.classList.contains('open')})[0]; if(!m) return null;
    var map={},order=[];
    $$('.b-slot',m).forEach(function(slot){var on=$('button[aria-pressed=true]',slot);if(!on)return;var id=on.getAttribute('data-id');if(!map[id]){map[id]=0;order.push(id)}map[id]++});
    return order.map(function(id){return {id:+id,quantity:map[id]}});
  }

  $$('input[name=b_pack]',root).forEach(function(r){
    r.addEventListener('change',function(){
      if(!r.checked) return; qty.value=r.value;
      var t=r.getAttribute('data-total'); if(total) total.textContent=t; if(sTotal) sTotal.textContent=t;
      openMix(+r.value);
    });
  });

  var form=$('[data-form]',root), cta=$('[data-cta]',root), sBtn=$('[data-sbtn]');
  if(form) form.addEventListener('submit',function(e){
    var items=mixItems(); if(!items||!items.length||!window.fetch) return;
    e.preventDefault(); if(cta) cta.classList.add('busy');
    var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok) throw r; location.href=base+'cart'})
      .catch(function(){if(cta) cta.classList.remove('busy'); form.submit()});
  });
  if(sBtn&&form&&!cta.disabled) sBtn.addEventListener('click',function(){form.requestSubmit?form.requestSubmit(cta):form.submit()});
  if(sticky&&cta){var st=function(){sticky.classList.toggle('on',cta.getBoundingClientRect().bottom<0)};window.addEventListener('scroll',st,{passive:true});st()}
})();
